import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import CustomPage from "components/CustomPage";
import { useEffect, useState } from "react";
import { apiUrl, boUrl } from "config/settings";
import { useDispatch, useSelector } from "react-redux";
import http from "http";
import { setDeleteMassage, setShowLoading } from "store/sysSlice";
import { DEPARTMENT_MANAGER, ROLES_ID } from "config/roles";
import moment from "moment/moment";
import { endpointName } from "./const";
import { setList, setServicesCallDetails } from "store/servicesCallSlice";
import { Stack } from "@mui/material";
import Header from "./Header";
import useDataManager from "hooks/useDataManager";
import TableData from "./components/TableData";
import GroupData from "./components/groupData";
import { createGoogleCalendarLink, getFromLocalStorage } from "config/functions";
import { useNavigate, useParams } from "react-router-dom";
import { COLORS } from "config/const";

const Active = () => {
  const navigate = useNavigate()
  const { removeItem } = useDataManager();
  const dispatch = useDispatch();
  const { bt } = useBizTypeTranslation();
  const { callId } = useParams()
  const user = useSelector((state) => state.userSettings?.user);
  const employeeslist = useSelector((state) => state?.employees?.list);
  const data = useSelector((state) => state?.servicesCall.list);
  const clientsList = useSelector((state) => state?.clients?.list);
  const [itemsList, setItemsList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [employeeId, setEmployeeId] = useState("all");
  const [selectedSt, setSelectedSt] = useState(1);
  const [selectedColor, setSelectedColor] = useState(null);
  const [workDt, setWorkDt] = useState(0);
  const [openQty, setOpenQty] = useState(0);
  const [waitingQty, setWaitingQty] = useState(0);
  const [displaySettings, setDisplaySettings] = useState(null);
  const [textSearch, setTextSearch] = useState("");
  const [now, setNow] = useState(moment());

  const STATUS_LIST = [
    { id: 1, title: `${bt("OPEN")} (${openQty})` },
    { id: 3, title: `${bt("WAITING")} (${waitingQty})` },
    { id: 4, title: `${bt("DODAY")} (${workDt})` },
  ]

  useEffect(() => {
    const updateNow = () => setNow(moment());

    const now = moment();
    const delayUntilNextMinute = 60000 - (now.seconds() * 1000 + now.milliseconds());

    const timeout = setTimeout(() => {
      updateNow();
      const interval = setInterval(updateNow, 60000);

      cleanup = () => clearInterval(interval);
    }, delayUntilNextMinute);

    let cleanup = () => clearTimeout(timeout);
    return () => cleanup();
  }, []);

  useEffect(() => {
    const settings = getFromLocalStorage("displaySettings");
    if (settings) {
      setDisplaySettings(settings);
    }

    else {
      const data = {
        type: "cards",
        show: {
          name: true,
          tel: true,
          addr: true,
          notes: true,
          workDt: true,
          clientCallId: true,
        },
      };
      setDisplaySettings(data);
      localStorage.setItem("displaySettings", JSON.stringify(data));
    }
  }, []);

  useEffect(() => {
    if (user?.userRole === ROLES_ID.EMPLOYEE) {
      setEmployeeId(user?.id);
    }
    getCallsList(user?.id);
  }, [user]);

  useEffect(() => {
    if (callId && data?.length > 0) {
      const findService = data?.find(item => item?.callId === callId)
      if (findService)
        dispatch(setServicesCallDetails({ ...findService, id: findService?._id }))
      navigate('/Service-Call/Active', { replace: true })
    }
  }, [callId, data]);

  useEffect(() => {
    setItemsList(data);
  }, [data]);

  useEffect(() => {
    filterDataTab();
  }, [selectedSt, selectedColor, employeeId, textSearch]);

  useEffect(() => {
    callTypeIdQty();
    filterDataTab();
  }, [itemsList]);

  const callTypeIdQty = () => {
    setOpenQty(itemsList?.filter((call) => call.stTypeId === 1)?.length);
    setWaitingQty(itemsList?.filter((call) => call.stTypeId === 3)?.length);
    setWorkDt(
      itemsList?.filter(
        (call) =>
          call.stTypeId === 1 &&
          call.workDt &&
          moment(call?.workDt).isSameOrBefore(moment(), 'day')
      )?.length
    );
  };

  const filterDataTab = () => {
    let list = [...itemsList];

    if (textSearch !== "") {
      list = list?.filter((call) =>
        call?.callId?.toString().includes(textSearch) ||
        call?.clienCompany?.toString().includes(textSearch) ||
        call?.clientCallId?.toString().includes(textSearch) ||
        call?.clientCallNumner?.toString().includes(textSearch) ||
        call?.clientId?.toString().includes(textSearch) ||
        call?.notes?.toString().includes(textSearch) ||
        call?.tel?.toString().includes(textSearch) ||
        call?.addr?.toString().includes(textSearch) ||
        call?.name?.toString().includes(textSearch) ||
        call?.contentWithItems?.some((item) => item?.toString().includes(textSearch))
      );
    }

    if (selectedSt !== "all") {
      if (selectedSt === 4)
        list = list?.filter((call) => call.stTypeId === 1 && call.workDt && moment(call?.workDt).isSameOrBefore(moment(), 'day'));
      else
        list = list?.filter((call) => call.stTypeId === selectedSt);
    }

    if (selectedColor !== "all" && selectedColor !== null) {
      list = list?.filter((call) => call.color === selectedColor);
    }

    if (employeeId !== "all") {
      list = list?.filter((call) => call.employee === employeeId);
    }

    list.sort((a, b) => {
      // if (a.hasFlag && !b.hasFlag) return -1;
      // if (!a.hasFlag && b.hasFlag) return 1;
      // const dateA = a.workDt ? new Date(a.workDt) :;
      // const dateB = b.workDt ? new Date(b.workDt) : new Date(b.created);
      // return dateA + dateB;
      return new Date(a.workDt) - new Date(b.workDt);
    });

    setFilterList(list);
  };

  const getCallsList = (id) => {
    dispatch(setShowLoading(true));

    if (user?.userRole === ROLES_ID.EMPLOYEE) {
      http.get(`${apiUrl}/${endpointName}/active/${id ?? employeeId}`)
        .then((res) => {
          dispatch(setList(res?.data?.data));
          setItemsList(res?.data?.data);
          dispatch(setShowLoading(false));
        });
    }

    else if (DEPARTMENT_MANAGER.includes(user?.userRole)) {
      http.get(`${apiUrl}/${endpointName}/active`).then((res) => {
        dispatch(setList(res?.data?.data));
        setItemsList(res?.data?.data);
        dispatch(setShowLoading(false));
      });
    }
  };

  const deleteServicesCall = (id, validation) => {
    dispatch(
      setDeleteMassage({
        validation: validation,
        massage: "DELETE_SERVICES_CALL",
        onClick: () => {
          dispatch(setShowLoading(true));
          http.delete(`${apiUrl}/${endpointName}/${id}`)
            .then((res) => {
              const newList = removeItem(id, data);
              dispatch(setList(newList));
              dispatch(setShowLoading(false));
            })
            .catch((error) => {
              dispatch(setShowLoading(false));
            });
        },
      })
    );
  };

  const createGoogleCalendar = (call) => {
    const startDt = call?.workDt || moment()
    const endDt = call?.workEndDt
      ? call?.workEndDt
      : call?.workDt
        ? moment(call?.workDt).add(1, 'hour')
        : moment().add(1, 'hour')

    const descriptionLines = [
      call?.clienCompany ? `${bt('COMPANY')}: ${call?.clienCompany}` : null,
      call?.name ? `${bt('CONTACT_NAME')}: ${call?.name}` : null,
      call?.tel ? `${bt('TEL')}: ${call?.tel}` : null,
      " ",
      `${bt('GOOGLE_CALENDAR_SERVICE_DESCRIPTION')}:`,
      `${boUrl}/Service-Call/Active/${call?.callId}`,
    ]
      ?.filter(Boolean)
      .join("\n");

    const link = createGoogleCalendarLink({
      title: `${bt('GOOGLE_CALENDAR_SERVICE_TITLE')}: ${call?.callId}`,
      location: call?.addr,
      description: descriptionLines,
      start: startDt,
      end: endDt,
    })
    window.open(link, '_blank')
  }

  return (
    <CustomPage
      hideTitle
      heightHeader={{ xs: 100, md: 40 }}
      header={
        <Header
          isActive
          showNewCall
          setDisplaySettings={setDisplaySettings}
          setSelectedSt={setSelectedSt}
          setSelectedColor={setSelectedColor}
          selectedColor={selectedColor}
          selectedSt={selectedSt}
          clientsList={clientsList}
          setItemsList={setItemsList}
          setTextSearch={setTextSearch}
          textSearch={textSearch}
          employeeId={employeeId}
          setEmployeeId={setEmployeeId}
          getCallsList={getCallsList}
          employeeslist={employeeslist}
          emplist={filterList}
          itemsList={itemsList}
          STATUS_LIST={STATUS_LIST}
        />
      }
    >
      <Stack height="100%">
        {displaySettings?.type === "table"
          ? <TableData
            createGoogleCalendar={createGoogleCalendar}
            displaySettings={displaySettings}
            deleteServicesCall={deleteServicesCall}
            filterlist={filterList}
          />
          : <GroupData
            createGoogleCalendar={createGoogleCalendar}
            now={now}
            displaySettings={displaySettings}
            deleteServicesCall={deleteServicesCall}
            filterlist={filterList}
          />
        }
      </Stack>
    </CustomPage>
  );
};
export default Active;
